import { ASSETS_URL } from "config";

const getImageUrl = (url: string): string => {
  return `${ASSETS_URL}${url}`;
};

export const getPartnerImageUrl = (url: string, cdnUrl: string): string => {
  return `${cdnUrl}${url}`;
};

export default getImageUrl;
